import React from 'react';

const ContactPersonInput = ({input, label, type, meta: {touched, error, warning}}) => {
    const formGroupErrorClass = (touched && error) ? 'has-danger' : '';
    const inputErrorClass = (touched && error) ? 'form-control-danger' : '';
    const errorMessage = (touched && error !== undefined) ? error: '';

    let classMap = new Map([
        ['linkedIn',  'fa fa-linkedin'],
        ['facebook',  'fa fa-facebook'],
        ['instagram',  'fa fa-instagram'],
        ['twitter',  'fa fa-twitter'],
    ]);
    let labelMap = new Map([
        ['linkedIn',  'LinkedIn'],
        ['facebook',  'Facebook'],
        ['instagram',  'Instagram'],
        ['twitter',  'Twitter'],
    ]);

    let labelType = labelMap.has(input.name)
        ? <span><i className={ `${classMap.get(input.name)}` } />&nbsp;<b>{labelMap.get(input.name)} <span className="text-muted">(valgfri)</span></b></span>
        : <b>{label}</b>;

    return (
        <div className={`form-group row ${formGroupErrorClass}`}>
            <label className="col-sm-2 col-form-label">{labelType}</label>
            <div className={`col-sm-10`}>
                <input
                    {...input}
                    autoComplete={'off'}
                    className={`form-control ${inputErrorClass}`}
                    type={type}
                />
                <div className="form-control-feedback">{errorMessage}</div>
            </div>
        </div>
    );
};

export default ContactPersonInput;




// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonInput.jsx